import script from "./WhitePauseIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./WhitePauseIcon.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__